import React, { useEffect } from "react";
import _get from "lodash/get";
import { forceCheck } from "react-lazyload";
import PromoProductsGrid from "@containers/Promo/PromoProductsGrid";
import PromoBanner from "@containers/Promo/PromoBanner";
import Heading from "@components/Heading";
import Button from "@components/Button";

const ProductsCategoryAllProducts = ({
  sort,
  filters,
  products: productsMap,
  category,
  campaign,
}) => {
  useEffect(() => {
    forceCheck();
  }, [sort, filters]);

  const iterateTree = ({ category, headingLevel = 2, showTitle = true }) => {
    if (category.subcategories) {
      return (
        <section key={category.id} className="mt-6 md:mt-0">
          {showTitle && (
            <div className="group-with-promoDarkTheme:text-white">
              <Heading
                display={`h${headingLevel}`}
                as={`h${headingLevel}`}
                title={category.name}
                classesProp="mb-4"
              />
            </div>
          )}

          {category.subcategories.map((subcateg) => (
            <React.Fragment key={subcateg.id}>
              {iterateTree({
                category: subcateg,
                headingLevel: showTitle ? headingLevel + 1 : headingLevel,
              })}
            </React.Fragment>
          ))}
        </section>
      );
    } else if (category.product_ids) {
      return (
        <article className={`mb-16`}>
          {showTitle && (
            <div className="group-with-promoDarkTheme:text-white">
              <Heading
                display={`h${headingLevel}`}
                as={`h${headingLevel}`}
                title={category.name}
                classesProp={`mb-4 ${headingLevel > 2 ? " text-xl" : ""}`} // XXX burn this line
              />
            </div>
          )}

          <PromoProductsGrid
            products={category.product_ids
              .map((id) => productsMap[id])
              .filter(Boolean)}
            sort={sort}
            category={category}
            filters={filters}
            campaign={campaign}
          />

          {_get(category, "properties.view_all_link", "") && (
            <div className="flex justify-center mt-10 w-full">
              <div className="w-full max-w-[260px]">
                <Button
                  title={
                    category.properties.view_all_text || "Vezi toata oferta"
                  }
                  display="block"
                  variant="primary"
                  href={category.properties.view_all_link}
                />
              </div>
            </div>
          )}

          {_get(category, "properties.banner1") && (
            <div className="mt-16">
              {_get(category, "properties.banner_link") ? (
                <a href={category.properties.banner_link}>
                  <PromoBanner
                    large={category.properties.banner1}
                    medium={category.properties.banner2}
                    small={category.properties.banner3}
                  />
                </a>
              ) : (
                <div>
                  {category.properties && (
                    <PromoBanner
                      large={category.properties.banner1}
                      medium={category.properties.banner2}
                      small={category.properties.banner3}
                    />
                  )}
                </div>
              )}
            </div>
          )}
        </article>
      );
    }

    return null;
  };

  return iterateTree({
    category: category,
    headingLevel: 2,
    showTitle: false,
  });
};

export default ProductsCategoryAllProducts;
